import { Link } from "react-router-dom";
import { ServicPageListAR } from "./servicePageData.js";
import { ServicPageListEN } from "./servicePageData.js";
import { useLanguage } from '../context/LanguageContext.js';
import { Helmet } from 'react-helmet';
import { getRoute, slugify } from "../utils/getRoute.js";
import { useLocation } from 'react-router-dom';

export default function ServicePage(){
    const { t, language} = useLanguage();
    const location = useLocation();
    const canonicalUrl = window.location.origin + location.pathname;
      const ServicList=language==="en"?ServicPageListEN:ServicPageListAR;
    const ServiceShow=ServicList.map((service)=>{
        return <Link to={getRoute('serviceDescription', language).replace(':slug', service.slug)} key={service.slug}>
        <div className="servicePage-card">
<div className="servicePage-card-img">
    <img src={service.img} alt="no-image"/>
</div>
<div className="servicePage-description-div">
<h4>{service.title}</h4>
<p>{service.small_description}</p>
</div>
        </div>
        
        </Link>
    });
    return <div className="container">
        <Helmet>
        <title>ام بي تك - Mptech خدمات </title>
        <link rel="canonical" href={canonicalUrl} />
         <meta 
          name="description" 
          content="يعرض فيها 16 خدمة بصور جذابة وشرح مبسط، سهولة التنقل بين الخدمات جميع الصور تظهر بتنسيق واحد في الأحجام والألوان"
        />
        <meta 
          name="keywords" 
          content="خدمات تقنية 
وكالة تسويق رقمي 
تسويق إلكتروني
المحامي الذكي
تصميم شعار
مواقع إلكترونية
تصميم تطبيقات
مصور تغطيات إعلامية
صيانة برمجيات
حملات بريد الكتروني
مصور افنت
تصميم تطبيقات للكمبيوتر
نظام محاسبي
اي ار بي
ERP
موقع تعريفي
صناعة موقع كبير
تحسين محركات البحث
ام بي تك
شركة تسويق في جدة
شركة تقنية في جدة"
        />
        </Helmet>
        <div className="servicePage-conatiner" >
        {ServiceShow}
        </div>
        
    </div>
}